export default "__VITE_ASSET__DarfZNZe__"